<script setup lang="ts">

import {router} from "@inertiajs/vue3";
import {route} from "ziggy-js";
import {MenuItem} from "@/types";

interface Props {
  value: MenuItem
}

const props = defineProps<Props>()
const emits = defineEmits(['click'])
const goToRoute = () => {
    router.visit(route(props.value.route), {
        onSuccess: () => {
            emits('click')
        }
    })
}
</script>

<template>
    <v-list-item
        density="compact"
        :slim="true"
        :prepend-icon="value.icon"
        :link="true"
        class="mx-5 pl-2"
        rounded="lg"
        @click="goToRoute"
    >
        <v-list-item-title class="text-subtitle-2 font-weight-regular">
            {{ value.label }}
        </v-list-item-title>
    </v-list-item>
</template>

<style scoped>

</style>
